import { useEffect, useState } from "react";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";
import { ConsultantuseAuth } from "../../../security/ConsultantUseAuth";
import { Get_One_Choose_Fields_From_MongoDB } from "../../../api/Get_One_Choose_Fields_From_MongoDB";

function OurTeam({ screenWidth }) {
  const { logoutConsultant } = ConsultantuseAuth();

  const [obj_EC, setobj_EC] = useState({});
  useEffect(() => {
    const fetchECData = async () => {
      Get_One_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        setobj_EC,
        logoutConsultant
      );
    };
    fetchECData();
  }, []);
  const [obj_Agency, setobj_Agency] = useState({});
  useEffect(() => {
    if (obj_EC.MetaData?.Agency_id && obj_EC.MetaData.Agency_id.length > 0) {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "Agencies",
        obj_EC.MetaData.Agency_id,
        {
          "MetaData.IP_id": 1,
          _id: 1,
          BasicInfo: 1,
        },
        setobj_Agency
      );
    }
  }, [obj_EC]);

  let Arr_Staff = [
    {
      name: "Richard Lawless",
      email: "richard.lawless@investin.org",
      description: "International Partnerships",
      photo:
        "https://media.licdn.com/dms/image/D4D03AQGvHljWW95rFw/profile-displayphoto-shrink_400_400/0/1682581811260?e=2147483647&v=beta&t=ky7EUVx68wNUIUdG4EPMenQeA3d9sWFKMfYZmEvyPw4",
      details: "For all your pre booking support",
      _id: "65c38d2d72976acb3923336c",
      Number: "+44 (0) 7593 563924",
      BookMeeting: "https://calendly.com/richardlawless-investin",
    },
    {
      name: "Shu-Han Chang",
      email: "shu@investin.org",
      description: "International Partnerships",
      photo:
        "https://media.licdn.com/dms/image/v2/C5603AQGJU7Hmj2oZqA/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1516771690372?e=2147483647&v=beta&t=756nm_OeSEHdEGckroViZETYbLD6ox4od4JbAsmvuLk",
      details: "For all your pre booking support",
      _id: "65c38d6972976acb3923336d",
    },
    {
      name: "Curtis",
      email: "curtis@investin.org",
      description: "Head of IT",
      photo:
        "https://media.licdn.com/dms/image/C4E03AQHLu92IDxD-nw/profile-displayphoto-shrink_200_200/0/1637082190802?e=2147483647&v=beta&t=oERrNItf6BSNwaBi49tffDiC3uANUqMw9zOd3hvgHt4",
      details: "For all your platform support",
    },
    {
      name: "Rebecca Joyce",
      email: "international@investin.org",
      description: "Senior International Student Experience Manager",
      photo:
        "https://media.licdn.com/dms/image/v2/C5603AQGCdgzhW4HVYw/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1637011448746?e=2147483647&v=beta&t=9-zRoIs0QY2eouFgPekhipiXncSxGb1EPhdIEysmSXg",
      details: "For all your post booking support",
    },
    {
      name: "Arsbi Amat",
      email: "international@investin.org",
      description: "International Student Experience Manager",
      photo: `${process.env.PUBLIC_URL}/ArsbiHeadshot.jpg`,
      details: "For all your post booking support",
    },
  ];
  return (
    <div class="w3-container w3-padding-64 w3-center" id="team">
      <h2>Meet the team :</h2>

      <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "row" }}>
        {Arr_Staff.map((obj_staff, index) => (
          <div
            style={{
              width: screenWidth === "Small" ? "99%" : "19.9%",
              marginBottom: "20px",
            }}
          >
            <a href={`mailto:${obj_staff.email}`}>
              <img
                src={obj_staff.photo}
                alt={obj_staff.name}
                style={{ width: "45%", maxHeight: "48%" }}
                class="w3-circle w3-hover-opacity"
              />
            </a>
            <h3>{obj_staff.name}</h3>

            {obj_staff._id === obj_Agency.MetaData?.IP_id ? (
              <h3>
                <b>
                  <i>
                    <u>Your Designated Contact</u>
                  </i>
                </b>
              </h3>
            ) : (
              <></>
            )}

            <p>
              {" "}
              <a
                href={`mailto:${obj_staff.email}`}
                style={{ textDecoration: "none" }}
              >
                <i class="fa fa-envelope-o w3-text-teal w3-xlarge"></i>{" "}
                {obj_staff.email}
              </a>
              <br></br>
              {obj_staff.description}
              <br></br>
              {obj_staff.details}
              <br></br>
              {obj_staff.Number ? (
                <>
                  <i class="fa fa-phone w3-text-teal w3-xlarge"></i>{" "}
                  {obj_staff.Number}
                  <br></br>
                </>
              ) : (
                <></>
              )}
              {obj_staff.BookMeeting ? (
                <>
                  <a
                    href={obj_staff.BookMeeting}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Calendly - {obj_staff.name}
                  </a>
                  <br></br>
                </>
              ) : (
                <></>
              )}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default OurTeam;
